import { render } from "./SkuComponents.vue?vue&type=template&id=ae7d31b0&scoped=true"
import script from "./SkuComponents.vue?vue&type=script&lang=js"
export * from "./SkuComponents.vue?vue&type=script&lang=js"

import "./SkuComponents.vue?vue&type=style&index=0&id=ae7d31b0&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7d31b0"]])

export default __exports__